module.exports = __webpack_public_path__ + "img/product_value_bg.7a96efc6.png";